// frontend/modules/customer-loan-info/stores/customer-loan-info-store.ts
import { create } from 'zustand';
import { CustomerLoanInfoState, CustomerLoanSearchParams } from '../types';

interface CustomerLoanInfoStore extends CustomerLoanInfoState {
  setSearchParams: (params: CustomerLoanSearchParams | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  reset: () => void;
}

const initialState: CustomerLoanInfoState = {
  searchParams: null,
  isLoading: false,
  error: null,
};

export const useCustomerLoanInfoStore = create<CustomerLoanInfoStore>((set) => ({
  ...initialState,
  
  setSearchParams: (params) => set({ searchParams: params }),
  
  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => set({ error }),
  
  clearError: () => set({ error: null }),
  
  reset: () => set(initialState),
}));
